var _a;
import Router from 'vue-router';
import { env } from '@funny/env';
// #region  解决唱吧 APP 内，安卓不支持前进后退的问题
if (env.browser.isChangba && env.browser.isAndroid && typeof ((_a = window.changbaCaller) === null || _a === void 0 ? void 0 : _a.addUrlCache) === 'function') {
    // 拦截编程式导航
    var oldPush_1 = Router.prototype.push;
    Router.prototype.push = function (location, onComplete, onAbort) {
        window.changbaCaller.addUrlCache(window.location.href);
        return oldPush_1.call(this, location, onComplete, onAbort);
    };
}
// #endregion
// #region 拦截编程式导航，自动添加 curuserid 和 token 参数
var interceptPushReplace = function (instance, location) {
    if (typeof location === 'string') {
        location = {
            path: location,
            query: {},
        };
    }
    else if (typeof location.query !== 'object') {
        location.query = {};
    }
    location.query.curuserid = location.query.curuserid || instance.currentRoute.query.curuserid;
    location.query.token = location.query.token || instance.currentRoute.query.token;
    if (instance.currentRoute.query.show_mode) {
        location.query.show_mode = location.query.show_mode || instance.currentRoute.query.show_mode;
    }
    return location;
};
// 拦截 push
var oldPush = Router.prototype.push;
Router.prototype.push = function (location, onComplete, onAbort) {
    location = interceptPushReplace(this, location);
    return oldPush.call(this, location, onComplete, onAbort);
};
// 拦截 replace
var oldReplace = Router.prototype.replace;
Router.prototype.replace = function (location, onComplete, onAbort) {
    location = interceptPushReplace(this, location);
    return oldReplace.call(this, location, onComplete, onAbort);
};
// #endregion
export default Router;
export { Router };
